export const acceptanceKind = {
    Accept: 1,
    Reject: 2,
}
